import {Face, FaceDTO} from 'src/common/models/facial-recognition/FaceDTO'
import {FacialListDTO} from 'src/common/models/facial-recognition/FacialListDTO'
import {ListFacialRecognitionDTO} from 'src/common/models/facial-recognition/ListFacialRecognitionDTO'
import axios from './_axios'
import {prepareParams} from './_internal'
import {AxiosResult, Paginate} from './_types'

const prefix = process.env.REACT_APP_FACIAL_BASE_URL

export type CreateListDTO = {
  name: string
  companyId: number
  clientId?: number
  listColor?: string
}

export type CreateFaceDTO = {
  name: string
  listsIds: Array<number>
  image: string
}

type getFaceListParams = {
  page: number
  pageSize: number
  search?: {
    faceName?: string
  }
  includes?: Array<string>
  filter?: {
    clientIds?: Array<number>
    ids?: Array<number>
    isKnown?: boolean
    listIds?: Array<number>
  }
}

type getListParams = {
  filter?: {
    clientIds?: Array<number>
    companyIds?: Array<number>
    ids?: Array<number>
  }
  search?: {
    listName?: string
  }
  includes?: Array<string>
}

export type GetFacesParams = {
  page?: number
  filter?: {
    clientIds?: Array<number>
    companyIds?: Array<number>
    ids?: Array<number>
  }
  search?: {
    listName?: string
    faceName?: string
  }
  includes?: Array<string>
}

type ResponseFacialDTO = {
  face: FaceDTO
  isNew: boolean
  distance: any | null
}

export type UpdateFace = {
  id: number
  recognitionId?: number
  name?: string
  listsIds?: number[]
  images?: Array<File>
  deleteFaceImageIds?: Array<number>
}

export type CreateFace = {
  name: string
  listsIds: number[]
  images: Array<File>
}

export type BindFaceDTO = {
  bind_at_face_id: number
  face_crop_image_key: string
}

type DeleteFaceDTO = {
  face_id: number
  list_id: number
}
export class FacialRecognitionEndpoint {
  async getFaces(params: GetFacesParams): Promise<AxiosResult<Paginate<Face>>> {
    return await axios.get(`${prefix}/faces`, {params: prepareParams(params)})
  }

  async getList(params: getListParams): Promise<AxiosResult<Paginate<ListFacialRecognitionDTO>>> {
    return await axios.get(`${prefix}/face-lists`, {params: prepareParams(params)})
  }

  async createFacialList(body: CreateListDTO): Promise<AxiosResult<any>> {
    return await axios.post(`${prefix}/face-lists`, body)
  }

  async updateFacialItemList(id: number, body: any): Promise<AxiosResult<any>> {
    return await axios.patch(`${prefix}/face-lists/${id}`, body)
  }

  async deleteFacialItemList(id: number): Promise<AxiosResult<any>> {
    return await axios.delete(`${prefix}/face-lists/${id}`)
  }
  async deleteManyFacialList(ids: number[]): Promise<AxiosResult<any>> {
    return await axios.delete(`${prefix}/face-lists`, {data: {ids}})
  }
  async createFacial(formData: FormData): Promise<AxiosResult<ResponseFacialDTO>> {
    return await axios.post(`${prefix}/faces`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  async getFacialList(params: getFaceListParams): Promise<AxiosResult<Paginate<FacialListDTO>>> {
    return await axios.get(`${prefix}/faces`, {params: prepareParams(params)})
  }

  async bindFace(body: BindFaceDTO): Promise<AxiosResult<Paginate<FacialListDTO>>> {
    return await axios.patch(`${prefix}/faces/bind`, body)
  }

  async updateFacial(formData: FormData): Promise<AxiosResult<ResponseFacialDTO>> {
    return await axios.patch(`${prefix}/faces`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  async deleteFacial(params: DeleteFaceDTO): Promise<AxiosResult<any>> {
    return await axios.delete(`${prefix}/faces`, {params: prepareParams(params)})
  }
}
